import { render, staticRenderFns } from "./CentralPeriodSection.vue?vue&type=template&id=5c31deca&scoped=true"
import script from "./CentralPeriodSection.vue?vue&type=script&lang=js"
export * from "./CentralPeriodSection.vue?vue&type=script&lang=js"
import style0 from "./CentralPeriodSection.vue?vue&type=style&index=0&id=5c31deca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31deca",
  null
  
)

export default component.exports